import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms'
//import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';

// Angular Material modules
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';

// NgModules
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenuModule } from '@progress/kendo-angular-menu';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { PagerModule } from '@progress/kendo-angular-pager';
import { PDFViewerModule } from "@progress/kendo-angular-pdfviewer";
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";
import { TelerikReportingModule } from '@progress/telerik-angular-report-viewer';
//import { MapModule, MapAPILoader, BingMapAPILoaderConfig, BingMapAPILoader, WindowRef, DocumentRef, MapServiceFactory, BingMapServiceFactory } from "angular-maps";
import { MaterialModule } from './material-module';
//import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

// Base
import { AppComponent } from './components/app/app.component';
import { BaseEndpoint } from './app.constants';
import { OAuthSettings } from './oauth';
import { LoginComponent } from './login/login.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';

// Other
import { rootRouterConfig } from './app.routes';
import { ShowRolesIfDirective, HideRolesIfDirective } from './directives/employee-role-if.directive';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';

//import * as pdfjs from 'pdfjs-dist';
//import * as pdfjs from 'pdfjs-dist';
//import {  } from 'pdfjs-dist/build/pdf-worker';
//require('pdfjs-dist/build/pdf-worker-entry.js');

// Factories

// Services
import { AlertsService } from './services/alerts.service';
import { ApplicationControlService } from './services/applicationcontrol.service';
import { AuthService } from './services/auth.service';
import { AzureMapsService } from './services/azure-maps.service';
import { CarrierTenderService } from './services/carrier-tender.service';
import { CityService } from './services/city.service';
import { CommentService } from './services/comment.service';
import { ContactService } from './services/contact.service';
import { CRMService } from './services/crm.service';
//import { CSEService, OpenLoadsService } from './services/cse.service';
import { CSEService } from './services/cse.service';
import { DataService } from './services/data.service';
import { EmailService } from './services/email.service';
import { EmployeeService } from './services/employees.service';
import { EncryptionService } from './services/encryption.service';
import { ERPService } from './services/erp.service';
import { ExportHubService } from './services/exporthub.service';
import { FileService } from './services/file.service';
import { GraphService } from './services/graph.service';
import { NotificationService } from './services/notification.service';
import { OrderService } from './services/order.service';
import { RecordLockService } from './services/recordlock.service';
import { SharedServicesModule } from './services/shared.services.module';
import { TMWService } from './services/tmw.service';
import { UtilService } from './services/util.service';
//import { ValueService } from './services/value.service';

// Interceptors
import { AuditHeaderInterceptor } from './interceptors/audit-header-interceptor'

// Pipes
import { OrderEventTypePipe } from './pipes/ordereventtype-pipe';
import { PhonePipe } from './pipes/phone-pipe';

// Components
import { ActionTypeForm } from './components/system-settings/action-type-form.component';
import { ActionTypeGrid } from './components/system-settings/action-type-grid.component';
import { AddCustomer, AddCustomerDialog } from './components/add-customer/add-customer.component';
import { AddCustomerAction, AddCustomerActionDialog } from './components/add-customer-action/add-customer-action.component';
import { AlertsComponent } from './components/alerts/alerts.component';
//import { AppControlSettings } from './components/system/app-control-settings.component';
import { CarrierAnalysisGrid } from './components/carrier/carrier-analysis-grid.component';
import { CarrierContactGrid } from './components/carrier-contact/carrier-contact-grid.component';
import { CarrierContractForm } from './components/carrier-offer/carrier-contract-form.component';
import { CarrierContractGrid } from './components/carrier-offer/carrier-contract-grid.component';
import { CarrierCustomerExclusionForm } from './components/carrier/carrier-customer-exclusion-form.component';
import { CarrierCustomerExclusionGrid } from './components/carrier/carrier-customer-exclusion-grid.component';
import { CarrierDetail } from './components/carrier/carrier-detail.component';
import { CarrierDropdown } from './components/carrier-dropdown/carrier-dropdown.component';
import { CarrierDropReasonForm } from './components/system-settings/carrier-drop-reason-form.component';
import { CarrierDropReasonGrid } from './components/system-settings/carrier-drop-reason-grid.component';
import { CarrierEquipmentForm } from './components/carrier/carrier-equipment-form.component';
import { CarrierEquipmentGrid } from './components/carrier/carrier-equipment-grid.component';
import { CarrierForm } from './components/carrier/carrier-form.component';
import { CarrierGeocodeLaneDetail } from './components/carrier/carrier-geocodelane-detail.component';
import { CarrierIncidentForm } from './components/carrier/carrier-incident-form.component';
import { CarrierIncidentGrid } from './components/carrier/carrier-incident-grid.component';
import { CarrierLaneForm } from './components/carrier-lane/carrier-lane-form.component';
import { CarrierLaneGrid } from './components/carrier-lane/carrier-lane-grid.component';
import { CarrierListGrid } from './components/carrier-list/carrier-list-grid.component';
import { CarrierOfferForm } from './components/carrier-offer/carrier-offer-form.component';
import { CarrierOfferGrid } from './components/carrier-offer/carrier-offer-grid.component';
import { CarrierQuickAdd } from './components/carrier/carrier-quick-add.component';
import { CarrierRepAssigned } from './components/carrier-rep/carrier-rep-assigned.component';
import { CarrierRepsAssignedStatsGrid } from './components/carrier-rep/carrier-reps-assigned-stats-grid.component';
import { CarrierRFQGrid } from './components/carrier/carrier-rfq-grid.component';
import { CarrierSales } from './components/carrier-sales/carrier-sales.component';
import { CarrierSalesBookedLoadsGrid } from './components/carrier-sales/carrier-sales-booked-loads-grid.component';
import { CarrierSalesLanesLoadsGrid } from './components/carrier-sales/carrier-sales-lanes-loads-grid.component';
import { CarrierSalesLoadsGrid } from './components/carrier-sales/carrier-sales-loads-grid.component';
import { CarrierSalesLoadsOfferGrid } from './components/carrier-sales/carrier-sales-loads-offer-grid.component';
import { CarrierSalesReleasedLoadsGrid } from './components/carrier-sales/carrier-sales-released-loads-grid.component';
import { CarrierSalesUnverifiedLoads } from './components/carrier-sales/carrier-sales-unverified-loads.component';
import { CarrierSearchGrid } from './components/carrier-list/carrier-search-grid.component';
import { CarrierServiceAssigned } from './components/carrier/carrier-service-assigned.component';
import { CarrierServiceForm } from './components/system-settings/carrier-service-form.component';
import { CarrierServiceGrid } from './components/system-settings/carrier-service-grid.component';
import { CarrierTeamAssigned } from './components/carrier/carrier-team-assigned.component';
import { CarrierTenderComponent, DeclineDialog, RateconConfirm } from './components/carrier-tender/carrier-tender.component';
import { CarrierTenderListComponent } from './components/carrier-tender-list/carrier-tender-list.component';
import { CheckCallForm } from './components/check-call-grid/check-call-form.component';
import { CheckCallGrid } from './components/check-call-grid/check-call-grid.component';
import { CityDropdown } from './components/city-dropdown/city-dropdown.component';
import { CityForm } from './components/city-dropdown/city-form.component';
import { CityStateZipDropdown } from './components/city-dropdown/city-state-zip-dropdown.component';
import { ConfirmDialog } from './components/modals/confirm-dialog.component';
import { ContactEmailPopup, ContactMultiselectDialog } from './components/contact/contact-email-popup.component';
import { ContactGrid } from './components/contact/contact-grid.component';
import { ContactQuickAdd } from './components/contact/contact-quick-add.component';
import { ContactQuickEdit } from './components/contact/contact-quick-edit.component';
import { ContactUnsubscribeComponent } from './components/contact-unsubscribe/contact-unsubscribe.component';
import { CounterComponent } from './components/counter/counter.component';
import { CrmCustomerActions } from './components/crm-customer-actions/crm-customer-actions.component';
import { CrmDashboard } from './components/crm-dashboard/crm-dashboard.component';
import { CrmFollowUps } from './components/crm-follow-ups/crm-follow-ups.component';
import { CrmHome } from './components/crm-home/crm-home.component';
import { CrmLeads } from './components/crm-leads/crm-leads.component';
import { CrmOpportunities } from './components/crm-opportunities/crm-opportunities.component';
import { CrmProspects } from './components/crm-prospects/crm-prospects.component';
import { CrossBorderForm } from './components/tracking-dashboard/cross-border-form.component';
import { CrossBorderGrid } from './components/tracking-dashboard/cross-border-grid.component';
import { CustomerActionForm } from './components/customer/customer-action-form.component';
import { CustomerActionGrid } from './components/customer/customer-action-grid.component';
import { CustomerChildForm } from './components/customer/customer-child-form.component';
import { CustomerChildGrid } from './components/customer/customer-child-grid.component';
import { CustomerDetail } from './components/customer/customer-detail.component';
import { CustomerDropdown } from './components/customer-dropdown/customer-dropdown.component';
import { CustomerForm } from './components/customer/customer-form.component';
import { CustomerHistoryGrid } from './components/customer/customer-history-grid.component';
import { CustomerList } from './components/customer-list/customer-list.component';
import { CustomerNotes } from './components/customer-profile/customer-notes.component';
import { CustomerOpportunityForm } from './components/customer/customer-opportunity-form.component';
import { CustomerOpportunityGrid } from './components/customer/customer-opportunity-grid.component';
import { CustomerOpportunityLaneGrid } from './components/customer/customer-opportunity-lane-grid.component';
import { CustomerOpportunityQuestion } from './components/customer/customer-opportunity-question.component';
import { CustomerOpportunitySalesCycle } from './components/customer/customer-opportunity-sales-cycle.component';
import { CustomerQuickAdd } from './components/customer-profile/customer-quick-add.component';
import { CustomerQuickEdit } from './components/customer-profile/customer-quick-edit.component';
import { CustomerStatusChecklistForm } from './components/customer/customer-status-checklist-form.component';
import { CustomerTeamAssigned } from './components/customer/customer-team-assigned.component';
import { CustomerTeamList } from './components/customer/customer-team-list.component';
import { DatepickerExample } from './components/datepicker/datepicker.component';
import { DocumentsForm } from './components/documents/documents-form.component';
import { DocumentsGrid } from './components/documents/documents-grid.component';
import { DocumentViewer } from './components/modals/document-viewer.component';
import { EditCustomerStatusChecklistOLD, CustomerStatusChecklistDialog } from './components/customer-status-checklist/customer-status-checklist-old.component';
import { EditOpportunityDialog } from './components/edit-opportunity/edit-opportunity.component';
import { EditSalesCycleCheckList, SalesCycleCheckListDialog } from './components/sales-cycle-checklist/sales-cycle-checklist.component';
import { EmployeeForm } from './components/system-settings/employee-form.component';
import { EmployeeGrid } from './components/system-settings/employee-grid.component';
import { EmployeeGroupAssign } from './components/system-settings/employee-group-assign.component';
import { EmployeeGroupForm } from './components/system-settings/employee-group-form.component';
import { EmployeeGroupGrid } from './components/system-settings/employee-group-grid.component';
import { EmployeePopup, EmployeeMultiselectDialog } from './components/employee-popup/employee-popup.component';
import { EmployeeRoleGrid } from './components/system-settings/employee-role-grid.component';
import { EmployeeRoleGroupAssign } from './components/system-settings/employee-role-group-assign.component';
import { FuelRateForm } from './components/system-settings/fuel-rate-form.component';
import { FuelRateGrid } from './components/system-settings/fuel-rate-grid.component';
import { FuelRateTierGrid } from './components/system-settings/fuel-rate-tier-grid.component';
import { SendEmailPopup, SendEmailDialog } from './components/send-email-popup/send-email-popup.component';
import { EpiContainer } from './components/epi-container/epi-container.component';
import { HomeComponent } from './components/home/home.component';
import { IndustryForm } from './components/system-settings/industry-form.component';
import { IndustryGrid } from './components/system-settings/industry-grid.component';
import { InitiativesDropdown } from './components/initiatives-dropdown/initiatives-dropdown.component';
import { InvoiceLineForm } from './components/invoice-line/invoice-line-form.component';
import { InvoiceLineGrid } from './components/invoice-line/invoice-line-grid.component';
import { ModeGrid } from './components/system-settings/mode-grid.component';
import { OpenLayersMap } from './components/map/openlayers-map.component';
import { OpenOfferGrid } from './components/carrier-offer/open-offer-grid.component';
import { OpportunityQuestionCategoryForm } from './components/system-settings/opportunity-question-category-form.component';
import { OpportunityQuestionCategoryGrid } from './components/system-settings/opportunity-question-category-grid.component';
import { OpportunityQuestionGrid } from './components/system-settings/opportunity-question-grid.component';
import { OrderForm } from './components/order-info/order-form.component';
import { OrderPlanned } from './components/order-planned/order-planned.component';
import { OrderPlannedCard } from './components/order-planned/order-planned-card.component';
import { OrderPlannedGrid } from './components/order-planned/order-planned-grid.component';
import { OrderStopCard } from './components/order-stop/order-stop-card.component';
import { OrderStopForm } from './components/order-stop/order-stop-form.component';
import { OrderStopGrid } from './components/order-stop/order-stop-grid.component';
import { OrderTracking } from './components/order-tracking/order-tracking.component';
import { PayDetailForm } from './components/pay-detail/pay-detail-form.component';
import { PayDetailGrid } from './components/pay-detail/pay-detail-grid.component';
import { RateIndexIndicator } from './components/rate-index/rate-index-indicator.component';
import { RecordLockModal } from './components/modals/record-lock-modal.component';
import { QuoteOrderEventNotificationForm } from './components/order-info/quoteorder-event-notification-form.component';
import { QuoteOrderLineForm } from './components/quoteorderline/quoteorderline-form.component';
import { QuoteOrderLineGrid } from './components/quoteorderline/quoteorderline-grid.component';
import { QuoteOrderLineHistoryGrid } from './components/quoteorderline/quoteorderline-history-grid.component';
import { QuoteOrderLineNotificationScheduleForm } from './components/quoteorderline/quoteorderlinenotificationschedule-form.component';
import { QuoteOrderLineCarrierServiceAssigned } from './components/carrier/quoteorderline-carrier-service-assigned.component';
import { QuoteOrderMasterForm } from './components/order-info/quoteordermaster-form.component';
import { QuoteOrderMasterGrid } from './components/order-info/quoteordermaster-grid.component';
import { ReferenceNumberForm } from './components/references/reference-number-form.component';
import { ReferenceNumberGrid } from './components/references/reference-number-grid.component';
import { RMISStatus } from './components/carrier/rmis-status.component';
import { SearchOfferGrid } from './components/carrier-offer/search-offer-grid.component';
import { SpinnerComponent } from './components/app/spinner.component';
import { SystemSettings } from './components/system-settings/system-settings.component';
import { TagMapList } from './components/tagmap/tagmap-list.component';
import { TagMapSelect } from './components/tagmap/tagmap-select.component';
import { TagTypeForm } from './components/system-settings/tag-type-form.component';
import { TagTypeGrid } from './components/system-settings/tag-type-grid.component';
import { TagTypeTag } from './components/tagmap/tagtype-tag.component';
import { TenderMaintenanceForm } from './components/system-settings/tender-maintenance-form.component';
import { ThirdPartyCompanyForm } from './components/system-settings/third-party-company-form.component';
import { ThirdPartyCompanyGrid } from './components/system-settings/third-party-company-grid.component';
import { ThirdPartyPayForm } from './components/pay-detail/third-party-pay-form.component';
import { ThirdPartyPayGrid } from './components/pay-detail/third-party-pay-grid.component';
import { TrackingDashboard } from './components/tracking-dashboard/tracking-dashboard.component';
import { TrailerTypeGrid } from './components/system-settings/trailer-type-grid.component';
import { TestPageComponent } from './components/test-page/test-page.component';
import { ToastrModule, ToastrService, Overlay, OverlayContainer } from 'ngx-toastr';

export const protectedResourceMap: [string, string[]][] = [
    ['https://graph.microsoft.com/v1.0/me', ['user.read']]
];

//const isIE = (typeof window !== 'undefined') ? (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1) : false;
const isIE = (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1);

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            ////   clientId: '6226576d-37e9-49eb-b201-ec1eeb0029b6', // Prod enviroment. Uncomment to use. 
            //clientId: '3fba556e-5d4a-48e3-8e1a-fd57c12cb82e', // PPE testing environment
            ////   authority: 'https://login.microsoftonline.com/common', // Prod environment. Uncomment to use.
            //authority: 'https://login.windows-ppe.net/common', // PPE testing environment.
            //redirectUri: '/',
            //postLogoutRedirectUri: '/'
            clientId: OAuthSettings.appId,
            authority: OAuthSettings.authority,
            //validateAuthority: true,
            redirectUri: encodeURI(window.location.origin + '/'),
            postLogoutRedirectUri: encodeURI(window.location.origin + '/'),
            navigateToLoginRequestUrl: true,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
        },
        system: {
            allowRedirectInIframe: true,
            allowNativeBroker: false, // Disables native brokering support
            loggerOptions: {
                //loggerCallback: (logLevel: LogLevel, message: string, containsPii: boolean): void  => {
                //    console.log("loggerCallback", logLevel, message);
                //    if (containsPii) {
                //        return;
                //    }
                //    switch (logLevel) {
                //        case LogLevel.Error:
                //            console.error(message);
                //            return;
                //        case LogLevel.Info:
                //            console.info(message);
                //            return;
                //        case LogLevel.Verbose:
                //            console.debug(message);
                //            return;
                //        case LogLevel.Warning:
                //            console.warn(message);
                //            return;
                //    }
                //},
                //logLevel: LogLevel.Info,
                loggerCallback,
                piiLoggingEnabled: false
            }
        }
    });
}

export function loggerCallback(logLevel: LogLevel, message: string, containsPii: boolean) {
    //console.log("loggerCallback", logLevel, message);
    if (containsPii) {
        return;
    }
    switch (logLevel) {
        case LogLevel.Error:
            console.error(message);
            return;
        case LogLevel.Info:
            console.info(message);
            return;
        case LogLevel.Verbose:
            console.debug(message);
            return;
        case LogLevel.Warning:
            console.warn(message);
            return;
    }
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
     protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
    //protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['user.read']);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['user.read']
        },
        loginFailedRoute: '/login'
    };
}

@NgModule({
    declarations: [
        ActionTypeForm,
        ActionTypeGrid,
        AddCustomer,
        AddCustomerDialog,
        AddCustomerAction,
        AddCustomerActionDialog,
        AlertsComponent,
        AppComponent,
        //AppControlSettings,
        NavMenuComponent,
        CounterComponent,
        DeclineDialog,
        HomeComponent,
        IndustryForm,
        IndustryGrid,
        LoginComponent,
        CarrierAnalysisGrid,
        CarrierContactGrid,
        CarrierContractForm,
        CarrierContractGrid,
        CarrierCustomerExclusionForm,
        CarrierCustomerExclusionGrid,
        CarrierDetail,
        CarrierDropdown,
        CarrierDropReasonForm,
        CarrierDropReasonGrid,
        CarrierEquipmentForm,
        CarrierEquipmentGrid,
        CarrierForm,
        CarrierGeocodeLaneDetail,
        CarrierIncidentForm,
        CarrierIncidentGrid,
        CarrierLaneForm,
        CarrierLaneGrid,
        CarrierListGrid,
        CarrierOfferForm,
        CarrierOfferGrid,
        CarrierQuickAdd,
        CarrierRepAssigned,
        CarrierRepsAssignedStatsGrid,
        CarrierRFQGrid,
        CarrierSales,
        CarrierSalesBookedLoadsGrid,
        CarrierSalesLanesLoadsGrid,
        CarrierSalesLoadsGrid,
        CarrierSalesLoadsOfferGrid,
        CarrierSalesReleasedLoadsGrid,
        CarrierSalesUnverifiedLoads,
        CarrierSearchGrid,
        CarrierServiceAssigned,
        CarrierServiceForm,
        CarrierServiceGrid,
        CarrierTeamAssigned,
        CarrierTenderComponent,
        CarrierTenderListComponent,
        CheckCallForm,
        CheckCallGrid,
        CityDropdown,
        CityForm,
        CityStateZipDropdown,
        ConfirmDialog,
        ContactEmailPopup,
        ContactMultiselectDialog,
        ContactGrid,
        ContactQuickAdd,
        ContactQuickEdit,
        ContactUnsubscribeComponent,
        CrmCustomerActions,
        CrmDashboard,
        CrmHome,
        CrmFollowUps,
        CrmLeads,
        CrmOpportunities,
        CrmProspects,
        CrossBorderForm,
        CrossBorderGrid,
        CustomerActionForm,
        CustomerActionGrid,
        CustomerChildForm,
        CustomerChildGrid,
        CustomerDetail,
        CustomerDropdown,
        CustomerForm,
        CustomerHistoryGrid,
        CustomerList,
        CustomerNotes,
        CustomerOpportunityForm,
        CustomerOpportunityGrid,
        CustomerOpportunityLaneGrid,
        CustomerOpportunityQuestion,
        CustomerOpportunitySalesCycle,
        CustomerQuickAdd,
        CustomerQuickEdit,
        CustomerStatusChecklistDialog,
        CustomerStatusChecklistForm,
        CustomerTeamAssigned,
        CustomerTeamList,
        DatepickerExample,
        DocumentsForm,
        DocumentsGrid,
        DocumentViewer,
        EditCustomerStatusChecklistOLD,
        EditOpportunityDialog,
        EditSalesCycleCheckList,
        EmployeeForm,
        EmployeeGrid,
        EmployeeGroupAssign,
        EmployeeGroupForm,
        EmployeeGroupGrid,
        EmployeePopup,
        EmployeeMultiselectDialog,
        EmployeeRoleGrid,
        EmployeeRoleGroupAssign,
        EpiContainer,
        FuelRateForm,
        FuelRateGrid,
        FuelRateTierGrid,
        HideRolesIfDirective,
        InitiativesDropdown,
        InvoiceLineForm,
        InvoiceLineGrid,
        ModeGrid,
        OpenLayersMap,
        OpenOfferGrid,
        OpportunityQuestionCategoryForm,
        OpportunityQuestionCategoryGrid,
        OpportunityQuestionGrid,
        OrderEventTypePipe,
        OrderForm,
        OrderPlanned,
        OrderPlannedCard,
        OrderPlannedGrid,
        OrderStopCard,
        OrderStopForm,
        OrderStopGrid,
        OrderTracking,
        PayDetailForm,
        PayDetailGrid,
        //pdfjs.PDFWorker,
        PhonePipe,
        RecordLockModal,
        QuoteOrderEventNotificationForm,
        QuoteOrderLineForm,
        QuoteOrderLineGrid,
        QuoteOrderLineHistoryGrid,
        QuoteOrderLineNotificationScheduleForm,
        QuoteOrderLineCarrierServiceAssigned,
        QuoteOrderMasterForm,
        QuoteOrderMasterGrid,
        RateconConfirm,
        RateIndexIndicator,
        ReferenceNumberForm,
        ReferenceNumberGrid,
        RMISStatus,
        SalesCycleCheckListDialog,
        SearchOfferGrid,
        SpinnerComponent,
        SystemSettings,
        SendEmailPopup,
        SendEmailDialog,
        ShowRolesIfDirective,
        TagMapList,
        TagMapSelect,
        TagTypeForm,
        TagTypeGrid,
        TagTypeTag,
        TenderMaintenanceForm,
        TestPageComponent,
        ThirdPartyCompanyForm,
        ThirdPartyCompanyGrid,
        ThirdPartyPayForm,
        ThirdPartyPayGrid,
        TrackingDashboard,
        TrailerTypeGrid
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule,
        CommonModule,
        DateInputsModule,
        DialogModule,
        DropDownsModule,
        FormsModule,
        ExcelExportModule,
        ExcelModule,
        GaugesModule,
        GridModule,
        IconsModule,
        IndicatorsModule,
        InputsModule,
        LayoutModule,
        LabelModule,
        //MapModule.forRootBing(),
        MaterialModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        //NewMatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        //MatNativeDateModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatStepperModule,
        MatTooltipModule,
        RouterModule.forRoot(rootRouterConfig, { useHash: true }),
        //MsalModule.forRoot({
        //    clientID: OAuthSettings.appId,
        //    authority: OAuthSettings.authority,
        //    validateAuthority: true,
        //    redirectUri: encodeURI(window.location.origin + '/'),
        //    cacheLocation: 'localStorage',
        //    postLogoutRedirectUri: encodeURI(window.location.origin + '/'),
        //    navigateToLoginRequestUrl: true,
        //    consentScopes: OAuthSettings.scopes
        //}),
        //MsalModule.forRoot({
        //    auth: {
        //        clientId: OAuthSettings.appId,
        //        authority: OAuthSettings.authority,
        //        validateAuthority: true,
        //        redirectUri: encodeURI(window.location.origin + '/'),
        //        postLogoutRedirectUri: encodeURI(window.location.origin + '/'),
        //        navigateToLoginRequestUrl: true,
        //        //consentScopes: OAuthSettings.scopes
        //    },
        //    cache: {
        //        cacheLocation: 'localStorage',
        //        storeAuthStateInCookie: isIE, // set to true for IE 11
        //    },
        //    framework: {
        //        unprotectedResources: ["https://www.microsoft.com/en-us/"],
        //        protectedResourceMap: new Map(protectedResourceMap)
        //    }
        //},
        //    {
        //        popUp: !isIE,
        //        //popUp: false,
        //        consentScopes: OAuthSettings.scopes,
        //        //unprotectedResources: ["https://www.microsoft.com/en-us/"],
        //        //protectedResourceMap,
        //        extraQueryParameters: {}
        //    }
        //),
        //MsalModule.forRoot(
        //    new PublicClientApplication({
        //        auth: {
        //            clientId: OAuthSettings.appId,
        //            authority: OAuthSettings.authority,
        //            //validateAuthority: true,
        //            redirectUri: encodeURI(window.location.origin + '/'),
        //            postLogoutRedirectUri: encodeURI(window.location.origin + '/'),
        //            navigateToLoginRequestUrl: true,
        //            //consentScopes: OAuthSettings.scopes
        //        },
        //        cache: {
        //            cacheLocation: 'localStorage',
        //            storeAuthStateInCookie: isIE, // set to true for IE 11
        //        }
        //    }),
        //    {
        //        // MSAL Guard Configuration
        //        interactionType: InteractionType.Redirect,
        //        authRequest: {
        //            scopes: ['user.read']
        //        },
        //        loginFailedRoute: '/login'
        //    },
        //    {
        //        // MSAL Interceptor Configuration
        //        interactionType: InteractionType.Redirect,
        //        protectedResourceMap: new Map([
        //            ['https://graph.microsoft-ppe.com/v1.0/me', ['user.read']]
        //        ])
        //    }
        //),
        MsalModule,
        MenuModule,
        NavigationModule,
        //NgxExtendedPdfViewerModule,
        OverlayModule,
        PagerModule,
        PDFViewerModule,
        PopupModule,
        ProgressBarModule,
        ReactiveFormsModule,
        SharedServicesModule,
        TelerikReportingModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        WindowModule
    ],
    providers: [
        { provide: BaseEndpoint, useValue: 'http://localhost:52337' },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        //{ provide: MapAPILoader, deps: [], useFactory: MapServiceProviderFactory },
        //ValueService,
        AlertsService,
        ApplicationControlService,
        AuthService,
        AzureMapsService,
        CarrierTenderService,
        CityService,
        CommentService,
        ContactService,
        CRMService,
        CSEService,
        DatePipe,
        DataService,
        EmailService,
        EmployeeService,
        EncryptionService,
        ERPService,
        ExportHubService,
        FileService,
        GraphService,
        MsalBroadcastService,
        MsalService,
        MsalGuard,
        NotificationService,
        OrderEventTypePipe,
        //OpenLoadsService,
        OrderService,
        Overlay,
        OverlayContainer,
        PhonePipe,
        RecordLockService,
        ToastrService,
        TMWService,
        UtilService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuditHeaderInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        provideHttpClient(withInterceptorsFromDi(), withFetch())
        //{
        //    provide: HTTP_INTERCEPTORS,
        //    useClass: MsalInterceptor,
        //    multi: true,
        //}
    ],
    // exports: [
    //     MsalModule,
    //     TelerikReportingModule
    //],
    bootstrap: [
        AppComponent,
        MsalRedirectComponent,
        DatepickerExample
    ]
})
export class AppModuleShared {
}
